export const INVENTORY_FILTERS = [
    {label: 'Yes', value: 'Yes'},
    {label: 'No', value: 'No'},
];